import React from "react";
import Agent from "./agent.jsx";

export const getAllConfiguration = async (barbershop) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const token = localStorage.getItem("authToken");
  const { requests } = Agent();
  return await requests.get(
    `/Configuration/all/${barbershop}`,
    token,
    barbershop
  );
};
export const updateAllConfiguration = async (barbershop) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const token = localStorage.getItem("authToken");
  const { requests } = Agent();
  return await requests.put(
    `/Configuration/${barbershop}`,
    null,
    token,
    barbershop
  );
};
export const updateConfigurations = async (config, barbershop) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const token = localStorage.getItem("authToken");
  const { requests } = Agent();
  const param = {
    ShopId: barbershop,
    Configs: config,
  };
  return await requests.put(`/Configuration/`, param, token, barbershop);
};
